/* eslint-disable no-undef */
import { styled } from '@mui/material';

export const Styles = {
  RectangleBar: styled('div')(({ theme }) => ({
    margin: '0 auto',
    height: '8px',
    backgroundColor: '#D9D9D9',
    marginBottom: '35px',
    marginTop: '-25px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '25px',
      marginTop: '-15px'
    }
  })),

  SectionFilters: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  })),

  ShowText: styled('div')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    color: '#212529',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  })),

  SelectContainer: styled('div')(({ theme }) => ({
    select: {
      padding: '5px',
      fontSize: '16px',
      border: '0.5px solid #5D5F64',
      borderRadius: '5px',
      backgroundColor: '#F8F8F8',
      '&:focus': {
        outline: 'none',
        borderColor: '#04682E'
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '15px'
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
        padding: '4px'
      }
    }
  })),

  RecordsText: styled('div')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    color: '#212529',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  })),

  SearchContainer: styled('div')(({ theme }) => ({
    width: '100%',
    marginBottom: '20px',
    [theme.breakpoints.up('sm')]: {
      width: '60%',
      marginBottom: '0'
    },
    [theme.breakpoints.up('md')]: {
      width: '50%'
    }
  })),

  SearchInput: styled('input')(({ theme }) => ({
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #5D5F64',
    borderRadius: '5px',
    backgroundColor: '#F8F8F8',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '15px'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      padding: '8px'
    }
  })),

  Buttons: styled('div')(({ theme }) => ({
    display: 'flex',
    gap: '10px',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 'auto',
      paddingLeft: '15px',
      paddingRight: '50px'
    },
    '& button': {
      padding: '8px 16px',
      borderRadius: '5px',
      border: 'none',
      cursor: 'pointer',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '20px',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 'auto'
      },
      '&:first-of-type': {
        backgroundColor: '#2C62C7',
        color: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#1E4A8E'
        }
      },
      '&:last-of-type': {
        backgroundColor: '#000000',
        color: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#333333'
        }
      }
    }
  })),

  Pagination: styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '5px',
    marginTop: '15px',
    marginBottom: '25px',
    padding: '0 20px',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
      padding: '0 10px 25px 0',
      gap: '10px'
    },
    button: {
      padding: '8px 12px',
      [theme.breakpoints.up('md')]: {
        padding: '8px 16px'
      },
      cursor: 'pointer',
      color: 'black',
      border: '1px solid #ddd',
      backgroundColor: 'white',
      borderRadius: '5px',
      fontSize: '14px',
      '&.active': {
        backgroundColor: 'black',
        color: 'white'
      },
      '&:disabled': {
        cursor: 'not-allowed',
        backgroundColor: 'white',
        color: 'black'
      }
    }
  })),

  UserCard: styled('div')(({ theme }) => ({
    width: '100%',
    minHeight: '90px',
    backgroundColor: '#FEF7FF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '15px',
    borderRadius: '8px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    marginBottom: '20px',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
      height: '90px'
    }
  })),

  UserIcon: styled('div')(({ theme }) => ({
    width: '40px',
    height: '40px',
    backgroundColor: '#D9D9D9',
    borderRadius: '50%',
    marginRight: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      width: '24px',
      height: '24px',
      borderRadius: '50%'
    },
    [theme.breakpoints.down('md')]: {
      position: 'absolute',
      top: '15px',
      left: '15px'
    }
  })),

  UserInfo: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    marginLeft: theme.breakpoints.down('md') ? '60px' : '0',
    marginBottom: theme.breakpoints.down('md') ? '15px' : '0',
    width: theme.breakpoints.down('md') ? 'calc(100% - 60px)' : 'auto'
  })),

  UserName: styled('div')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '1px',
    color: '#212529',
    [theme.breakpoints.down('md')]: {
      lineHeight: '20px',
      marginBottom: '5px'
    }
  })),

  UserContact: styled('div')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#6C757D',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
      lineHeight: '16px'
    }
  })),

  FlexContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '20px',
    [theme.breakpoints.up('md')]: {
      marginBottom: '0'
    }
  }))
};
